import { Pipe, PipeTransform } from '@angular/core';
import { ICartProduct } from '../../models/cart.model';

@Pipe({
  name: 'productCountCart'
})
export class ProductCountCartPipe implements PipeTransform {

  transform(cartProducts: ICartProduct[] | null, id: string): number {
    const cartProduct = cartProducts?.find(item => item.id === id);
    if (cartProduct) {
      return cartProduct.quantity;
    } else {
      return 0;
    }
  }

}
